import type { User } from '@entities/user';
import type {
  UserLoginAuthenticator,
  UserLoginRequest,
} from '@usecases/user-login.usecase';
import { BUS_IFRAME_ELM_ID } from '@main/config/bus.config';
import { BusAuthentication } from '@main/bus-layer/bus-authentication';

export class BusUserLoginAuthenticator implements UserLoginAuthenticator {
  private static Ins: BusUserLoginAuthenticator;

  constructor() {
    return (
      BusUserLoginAuthenticator.Ins ?? (BusUserLoginAuthenticator.Ins = this)
    );
  }

  async authenticate({ email, password }: UserLoginRequest): Promise<User> {
    const target: HTMLIFrameElement = <HTMLIFrameElement>(
      document.getElementById(BUS_IFRAME_ELM_ID)
    );

    const {
      company,
      currentUser: info,
      credentials,
    } = await BusAuthentication.loginByEmailAndPassword(
      target,
      email,
      password,
    );

    return {
      company,
      credentials,
      info,
    };
  }
}
